export default __webpack_public_path__ + "static/rovo-thinking-skeleton-dark-57cbc06f75a0ce66a76d17ac580020434f64433d94628de4362ae7ae99b08ff7.png";